<!--地址选择器-->
<template>
  <div>
    <van-popup
      :style="{ height: '60%' }"
      position="bottom"
      @click-overlay="onClose"
      :close-on-click-overlay="false"
      v-model="show"
    >
      <div class="address-list-select">
        <div class="address-add-item" @click="addressAdd">新增收货地址</div>
        <van-cell-group>
          <van-cell
            v-for="address in list"
            center
            :title="address.name + ' ' + address.phone"
            is-link
            @click="onSelect(address)"
            :label="address.address"
            :key="address.id"
          >
          </van-cell>
        </van-cell-group>
      </div>
    </van-popup>

    <van-popup
      position="bottom"
      :style="{ height: '70%' }"
      v-model="showAdd"
      @click-overlay="onClose"
    >
      <div class="address-form">
        <van-cell-group>
          <van-field
            v-model="formData.name"
            label="姓名"
            :error="formValidate && !formData.name"
            placeholder="收货人姓名"
          />
          <van-field
            v-model="formData.phone"
            label="电话"
            :error="formValidate && !formData.phone"
            type="number"
            placeholder="收货人电话"
          />
          <van-field
            @click="area_show = true"
            readonly
            :value="formData.province + formData.city + formData.county"
            :error="formValidate && !formData.county"
            label="地区"
            placeholder="选择省/市/区"
          />
          <van-field
            v-model="formData.address"
            label="详细地址"
            :error="formValidate && !formData.address"
            placeholder="街道门牌、楼层房间号等信息"
          />
          <van-cell title="设为默认收货地址">
            <van-switch
              size="24px"
              active-color="#f44"
              v-model="formData.is_default"
            />
          </van-cell>
        </van-cell-group>
        <div class="distinguish">
          <van-field
            v-model="distinguish_address"
            rows="2"
            autosize
            label=""
            type="textarea"
            placeholder="智能识别地址"
          />
        </div>
          <a class="distinguish-btn" @click="onSmartParse">智能识别</a>

        <div style="padding: 20px">
          <van-button type="danger" round size="large" @click.stop="formSave"
            >保存</van-button
          >
        </div>
        <div
          v-show="area_show"
          style="position: fixed; bottom: 0; z-index: 1000; width: 100%"
        >
          <van-area
            :area-list="areaList"
            :value="formData.area_key"
            @confirm="areaConfirm"
            @cancel="areaCancel"
          />
        </div>
      </div>
    </van-popup>
  </div>
</template>
<style scope>
.distinguish-btn{
  text-align: center;
  color: #4a90e2;
  margin: 0.1rem auto;
  display: block;
}
.distinguish {
  /* padding: 0 0.2rem; */
  width: 7.1rem;
  margin: 0 auto;
  border: 1px solid #f5f5f5;
  border-radius: 10px;
  overflow: hidden;
}
/*.van-popup-bottom {
      top: 40%!important;
  }*/
.address-list-select {
  /*padding: 20px 0 ;*/
  background-color: #fff;
  /*overflow-y: scroll*/
}

.address-add-item {
  /*position: relative; !*padding: 10px 18px;*!*/
  padding: 15px 18px;
  color: #4a90e2;
  font-size: 14px;
}

/*.address-add-item:after {*/
/*  content: '';*/
/*  position: absolute;*/
/*  left: 1.8rem;*/
/*  right: 0;*/
/*  bottom: 0;*/
/*  border-bottom: 1px solid #d9d9d9;*/
/*  transform: scaleY(0.5);*/
/*}*/
</style>

<script>
import areaList from "@/utils/area";
import { Popup, CellGroup, Cell, Switch, Area } from "vant";

export default {
  name: "AddressPicker",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    [Popup.name]: Popup,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Switch.name]: Switch,
    [Area.name]: Area,
  },
  data() {
    return {
      showAdd: false,
      distinguish_address: "",
      formData: {
        name: "",
        phone: "",
        area_names_string: "",
        area_key: "",
        address: "",
        province: "",
        city: "",
        county: "",
        is_default: true,
      },
      selectAddress: {},
      areaList: areaList,
      list: [],
      area_show: false,
      formValidate: false,
    };
  },

  watch: {
    show(val) {
      if (val) {
        this.getList();
      }
    },
  },
  mounted: function () {},
  methods: {
    onSmartParse() {
      let that = this;
      this.$api.get(
        "/api/utils/smartParse",
        { address: this.distinguish_address },
        (res) => {
          console.log(res);
          let address = "";
          res.data.detail.map((item, i) => {
            if (i == 0) {
              that.formData.province = item.name;
            }
            if (i == 1) {
              that.formData.city = item.name;
            }
            if (i == 2) {
              that.formData.county = item.name;
            }
            if (i <= 2) {
              address += item.name;
            }
          });
          that.formData.phone = res.data.phone;
          that.formData.name = res.data.name;
          that.formData.area_names_string=that.formData.province+'-'+that.formData.city+'-'+that.formData.county
          that.formData.area_key =
            res.data.detail[res.data.detail.length - 2].area_key;
          that.formData.address =
            address + res.data.detail[res.data.detail.length - 1].name;
        }
      );
    },
    getList() {
      let that = this;
      this.$api.get("/api/user/addressList", {}, (res) => {
        console.log(res);
        let showAdd = res.data.length > 0 ? false : true;
        that.list = res.data;
        that.showAdd = showAdd;
      });
    },
    addressAdd() {
      let that = this;
      that.showAdd = true;
    },
    onSelect(address) {
      let that = this;
      that.selectAddress = address;
      that.onChange();
    },
    onClose() {
      this.showAdd = false;
      this.$emit("onClose", {});
    },

    onChange() {
      let that = this;
      // console.log('onChange',{ address: that.data.selectAddress, address_id: that.data.selectAddress.id });
      this.$emit("onChange", {
        address: that.selectAddress,
        address_id: that.selectAddress.id,
      });
      that.onClose();
    },
    areaConfirm(data) {
      let that = this;
      console.log(data);
      that.formData.province = data[0].name;
      that.formData.city = data[1].name;
      that.formData.county = data[2].name;
      that.formData.area_key = data[2].code;
      that.formData.area_names_string =
        data[0].name + "-" + data[1].name + "-" + data[2].name;
      this.area_show = false;
    },
    areaCancel() {
      this.area_show = false;
    },

    formSave: function () {
      let that = this;
      that.formValidate = true;
      console.log("that.formData", that.formData);
      for (let field in that.formData) {
        if (!that.formData[field] && field != "is_default") {
          return;
        }
      }
      this.$api.get(
        "/api/user/addressAdd",
        {
          //$name, $phone, $address ,$area_key,$province,$city,$county,$is_default=''
          name: that.formData.name,
          phone: that.formData.phone,
          address: that.formData.address,
          area_key: that.formData.area_key,
          province: that.formData.province,
          city: that.formData.city,
          county: that.formData.county,
          is_default: that.formData.is_default ? 1 : 2,
        },
        (res) => {
          console.log(res);
          that.selectAddress = res.data;
          that.formValidate = false;
          that.formData = {
            name: "",
            phone: "",
            area_names_string: "",
            area_key: "",
            address: "",
            province: "",
            city: "",
            county: "",
            is_default: true,
          };
          that.onChange();
        }
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// AddressPicker.vue?48542a7c